export const BooleanRow = ({num = -1, stmt, text}) => {
    return (
        <div className="d-flex flex-row align-items-center fs-5 gap-2">
            {num !== -1 && (
                <div className="d-flex flex-column">
                    <div className="symbol symbol-30px me-2">
                        <div className="symbol-label fs-5 fw-semibold bg-primary text-inverse-danger">{num}</div>
                    </div>
                </div>
            )}
            <div className="flex-grow-1 fw-bold">{stmt}</div>
            <div className="rating">
                {text === "Yes" ? (
                    <div className="badge badge-lg badge-success">Yes</div>
                ) : (
                    <div className="badge badge-lg badge-warning">No</div>
                )}
            </div>
        </div>
    )
}

export default BooleanRow
